'use client'

import * as React from 'react'
import { clsx } from 'clsx'

import { MktInput, MktInputProps } from './input'
import { useLantern } from '../../hooks/use-lantern'

type LanternInputProps = {
  className?: string
  inputProps: MktInputProps
}

export const LanternInput = React.forwardRef<
  HTMLInputElement,
  LanternInputProps
>(({ className, inputProps }, ref) => {
  const { elementRef, maskRef, focusHandlers } = useLantern<HTMLInputElement>({
    size: 'sm',
    isFocused: inputProps.autoFocus,
  })

  return (
    <div className={clsx(className, 'relative')} ref={elementRef}>
      {/* real input */}
      <MktInput
        {...inputProps}
        className={clsx(
          'focus:border-dark-border cursor-default',
          inputProps.className
        )}
        ref={ref}
        onFocus={(e) => {
          if (inputProps.onFocus) inputProps?.onFocus(e)
          focusHandlers.onFocus()
        }}
        onBlur={(e) => {
          if (inputProps.onBlur) inputProps?.onBlur(e)
          focusHandlers.onBlur()
        }}
      />
      {/* mask input (contains orange border) */}
      <MktInput
        className={clsx(
          '!border-dark-control-base pointer-events-none absolute top-0 left-0 z-10 cursor-default !bg-[transparent] opacity-0',
          inputProps.className
        )}
        ref={maskRef}
        style={{ ['--opacity' as string]: 0, opacity: 'var(--opacity)' }}
        disabled
        aria-hidden
      />
    </div>
  )
})
